import React from 'react';
import LocationTemplate from './LocationTemplate';

const LouisburgPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Louisburg"
      stateName="North Carolina"
      countyName="Franklin"
      zipCodes={["27549"]}
      latitude={36.0993}
      longitude={-78.3011}
      population={3503}
      historicalFact="Home to Louisburg College (1787), one of the oldest two-year colleges in the nation."
      nearbyTowns={[
        "Raleigh, NC",
        "Wake Forest, NC",
        "Franklinton, NC",
        "Youngsville, NC",
        "Bunn, NC",
        "Henderson, NC",
        "Zebulon, NC",
        "Rolesville, NC"
      ]}
    />
  );
};

export default LouisburgPage;